import { Text, Box, FormControl, FormLabel, Input } from "@chakra-ui/react";

//import useref
import { useRef, useEffect } from "react";

export default function JobOpportunity() {
  const refContainer = useRef(null);
  useEffect(() => {
    refContainer.current.scrollIntoView({ behavior: "smooth" });
  }, []);
  return (
    <div id="job-opportunity" ref={refContainer}>
      <Box
        background="white"
        minHeight="100vh"
        marginInlineStart={{ base: "none", md: "0.1rem", xl: "1rem" }}
        padding="1rem"
        textAlign="center"
      >
        <Text fontSize="30px" fontWeight={700}>
          Job Opportunity
        </Text>
        <Box padding="1rem" textAlign="start">
          <Text fontSize="24px" fontWeight={500}>
            Current Openings
          </Text>
          <Text fontSize="20px" fontWeight={700}>
            1. Researcher
          </Text>
          <Text fontSize="17px">What We are looking for:</Text>
          <Box padding="1rem" marginLeft="40px">
            <ul>
              <li>first requirement</li>
              <li>second requirement</li>
              <li>third requirement</li>
              <li>fourth requirement</li>
            </ul>
          </Box>
          <Text fontSize="17px">Educational Requirement</Text>
          <Box padding="1rem" marginLeft="40px">
            <ul>
              <li>first requirement</li>
              <li>second requirement</li>
              <li>third requirement</li>
              <li>fourth requirement</li>
            </ul>
          </Box>
          <Text
            fontSize={{ base: "18px", md: "20px", lg: "22px", xl: "24px" }}
            textAlign="center"
          >
            If you think you are the right candidate for this, please fill up
            the form below
          </Text>
          <Box
            width={{ base: "90%", md: "70%", lg: "60%", xl: "50%" }}
            marginX="auto"
          >
            <form>
              <FormControl id="name" margin="1rem" isRequired>
                <FormLabel>Name</FormLabel>
                <Input
                  type="text"
                  name="user_name"
                  borderLeft="0"
                  borderRight="0"
                  borderTop="0"
                  borderRadius="none"
                  _focus={{
                    borderLeft: "0",
                    borderRight: "0",
                    borderTop: "0",
                    borderRadius: "none",
                    zIndex: "0",
                    boxShadow: "none",
                  }}
                />
              </FormControl>

              <FormControl id="email" margin="1rem" isRequired>
                <FormLabel>Email address</FormLabel>
                <Input
                  type="email"
                  name="user_email"
                  borderLeft="0"
                  borderRight="0"
                  borderTop="0"
                  borderRadius="none"
                  _focus={{
                    borderLeft: "0",
                    borderRight: "0",
                    borderTop: "0",
                    borderRadius: "none",
                    zIndex: "0",
                    boxShadow: "none",
                  }}
                />
              </FormControl>
              <FormControl id="phone-number" margin="1rem" isRequired>
                <FormLabel>Phone Number</FormLabel>
                <Input
                  type="number"
                  name="user_number"
                  borderLeft="0"
                  borderRight="0"
                  borderTop="0"
                  borderRadius="none"
                  _focus={{
                    borderLeft: "0",
                    borderRight: "0",
                    borderTop: "0",
                    borderRadius: "none",
                    zIndex: "0",
                    boxShadow: "none",
                  }}
                />
              </FormControl>
              <FormControl id="position" margin="1rem" isRequired>
                <FormLabel>Position Name</FormLabel>
                <Input
                  type="text"
                  name="user_position"
                  borderLeft="0"
                  borderRight="0"
                  borderTop="0"
                  borderRadius="none"
                  _focus={{
                    borderLeft: "0",
                    borderRight: "0",
                    borderTop: "0",
                    borderRadius: "none",
                    zIndex: "0",
                    boxShadow: "none",
                  }}
                />
              </FormControl>

              <FormControl id="resume" margin="1rem" isRequired>
                <FormLabel>Upload Resume</FormLabel>
                <Input
                  type="file"
                  name="user_resume"
                  border="0"
                  borderRadius="none"
                  _focus={{
                    border: "0",
                    borderRadius: "none",
                    zIndex: "0",
                  }}
                />
              </FormControl>

              <Box display="flex" justifyContent="center">
                <Box
                  width={{
                    base: "100%", // 0-48em
                    md: "50%", // 48em-80em,
                    xl: "50%", // 80em+
                  }}
                  alignItems="center"
                  as="button"
                  mt="2%"
                  p={2}
                  color="white"
                  fontWeight="bold"
                  borderRadius="md"
                  bgColor="#473198"
                  transition="background 0.3s ease-in"
                  _hover={{
                    bgColor: "black",
                    color: "white",
                  }}
                  name="user_name"
                  type="submit"
                  value="Send"
                >
                  Submit
                </Box>
              </Box>
            </form>
          </Box>
        </Box>
      </Box>
    </div>
  );
}
